import React from 'react';
import PropTypes from 'prop-types';
import AuthTop from 'components/AuthTop';
import AuthWrapper from 'components/AuthWrapper';
import FormErrors from 'components/FormErrors';
import './NotificationWindow.css';

function NotificationWindow({
  message,
  title,
  onClose,
  closeUrl,
  variant,
  customContent
}) {
  return (
    <div className="notification-window">
      <AuthWrapper onClose={onClose} closeUrl={closeUrl}>
        <AuthTop hideLogo>
          {title && (
            <div className="notification-title" role="heading" aria-level="1">
              {title}
            </div>
          )}
          {customContent ? (
            <>{customContent}</>
          ) : (
            <FormErrors errors={[message]} variant={variant} />
          )}
        </AuthTop>
      </AuthWrapper>
    </div>
  );
}

AuthWrapper.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  closeUrl: PropTypes.string,
  onClose: PropTypes.func
};

export default NotificationWindow;
